//nuitaLHotel.js

import React from 'react';
import Particles from 'react-particles';
//import {loadFull} from 'tsparticles';
import { useCallback } from 'react';
import { loadSlim } from "tsparticles-slim";
import './projet.css';

function Manifeste() {
      const image = require('./image/gamjam.png');

      const particlesInit = useCallback(async engine => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        //await loadFull(engine);
        await loadSlim(engine);
      }, []);
  
      const particlesLoaded = useCallback(async container => {
          await console.log(container);
      }, []);

      return (
      <div className='flex'>
        <a href="/" className='back'>Back to Main Page</a>
        <h1>Le Manifeste</h1>
        <p className='center'><i>Develop with Unreal Engine 5.4</i></p>
        <img src={image} alt="img" />
        <div className='download'><a href="https://numieow.itch.io/le-manifeste" className='itchio'>Play the game on Itch.io</a></div>
      <div className="paragraph-container">
        <h3>Game Overview</h3>
        <p>The player embodies a newcomer in a city where the ruling power oppresses the people. With the revolt having been crushed, the player's objective is to restore order by reminding the people of the fight they must undertake.</p>

        <h3>Gameplay</h3>
        <p>The player must gather the old manifestos that the revolt had distributed but were lost. Once these manifestos are reassembled, you will need to create your own manifesto to inspire the people.</p>

        <div className="columns">
        <div className="column">
            <h4>Level Designer</h4>
            Noé-Laurent Laurent
        </div>
        <div className="column">
            <h4>Lighting Designer</h4>
            Noé-Laurent Laurent
        </div>
        <div className="column">
            <h4>Developers</h4>
            <ul>
                <li>Antoine Yebouet</li>
                <li>Maxime Wirth</li>
                <li>Noé-Laurent Laurent</li>
                <li>Thibault Boisseau</li>
            </ul>
        </div>
        <div className="column">
            <h4>Artists</h4>
            <ul>
            <li>Maud Petit</li>
            <li>Maxime Wirth</li>
            </ul>
        </div>
        <div className="column">
            <h4>Scénarists</h4>
            <ul>
            <li>Maud Petit</li>
            <li>Maxime Wirth</li>
            </ul>
        </div>
        <div className="column">
            <h4>Sound Designer</h4>
            Antoine Yebouet
        </div>

        <div className="column">
            <h4>UI Designer</h4>
            Thibault Boisseau
        </div>
        </div>
        </div>
        <div className='particles-container'>
      <Particles 
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
            background: {
                color: {
                    value: "#0d47a1",
                },
            },
            fpsLimit: 120,
            interactivity: {
                events: {
                    onClick: {
                        enable: true,
                        mode: "push",
                    },
                    onHover: {
                        enable: true,
                        mode: "repulse",
                    },
                    resize: true,
                },
                modes: {
                    push: {
                        quantity: 4,
                    },
                    repulse: {
                        distance: 200,
                        duration: 0.4,
                    },
                },
            },
            particles: {
                color: {
                    value: "#ffffff",
                },
                links: {
                    color: "#ffffff",
                    distance: 150,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
                },
                move: {
                    direction: "none",
                    enable: true,
                    outModes: {
                        default: "bounce",
                    },
                    random: false,
                    speed: 6,
                    straight: false,
                },
                number: {
                    density: {
                        enable: true,
                        area: 800,
                    },
                    value: 80,
                },
                opacity: {
                    value: 0.5,
                },
                shape: {
                    type: "circle",
                },
                size: {
                    value: { min: 1, max: 5 },
                },
            },
            detectRetina: true,
        }}
      />
      </div>
    </div>
    );
  }
  
  export default Manifeste;
